import React, { useEffect, useState } from "react";
import "./Products.css";
import Card from "../../components/ProductCard/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons";
import SideDrawer from "../../components/SideDrawer/SideDrawer";
import base_url from "../../../src/api";
import MeasurementForm from "../../pages/mesurement/MeasurementForm";
import Cart from "../../pages/cart/Cart"; // ✅ Correct import (capital C)

const Products = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({
    category: "",
    size: "",
    color: "",
  });
  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    sizes: [],
    colors: [],
  });

  // ✅ Step management (now 5 steps)
  const [step, setStep] = useState(1);
  const steps = ["Kurta", "Pajama", "Shawl", "Measurement", "Cart"];

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  // ✅ Fetch all products from API
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const res = await fetch(`${base_url}/products`);
        const data = await res.json();
        setProducts(data);
        setFilteredProducts(data);

        const categories = [...new Set(data.map((p) => p.category))];
        const sizes = [
          ...new Set(data.flatMap((p) => (p.size ? p.size.split(",") : []))),
        ];
        const colors = [
          ...new Set(
            data.flatMap((p) =>
              p.images ? Object.keys(p.images || {}) : []
            )
          ),
        ];

        setFilterOptions({ categories, sizes, colors });
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchdata();
  }, []);

  // ✅ Filter by subcategory based on current step (only for 1–3)
  useEffect(() => {
    if (step <= 3) {
      const subcategory = steps[step - 1];
      const filtered = products.filter(
        (p) =>
          p.subcategory &&
          p.subcategory.toLowerCase() === subcategory.toLowerCase()
      );
      setFilteredProducts(filtered);
    }
  }, [step, products]);

  // ✅ Reset filters
  const resetFilters = () => {
    setFilters({ category: "", size: "", color: "" });
    setFilteredProducts(products);
  };

  return (
    <div className="productContainer">
      {/* ✅ Always show toolbar & stepper */}
      <div className="toolbar">
        <div className="toolbar-left">
          {step <= 3 && (
            <button className="filter-btn" onClick={toggleDrawer}>
              <FontAwesomeIcon icon={faSlidersH} /> Filters
            </button>
          )}
        </div>

        {/* ✅ Clickable Stepper (now includes Cart) */}
        <div className="stepper-container">
          {steps.map((s, index) => (
            <div
              className="stepper-item"
              key={index}
              onClick={() => setStep(index + 1)}
              style={{ cursor: "pointer" }}
            >
              <div
                className={`step-circle ${index + 1 <= step ? "active" : ""}`}
              >
                {index + 1}
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`step-line ${index + 1 < step ? "active" : ""}`}
                ></div>
              )}
              <div
                className={`step-label ${
                  index + 1 === step ? "active-label" : ""
                }`}
              >
                {s}
              </div>
            </div>
          ))}
        </div>

        <div className="toolbar-right">
          {step <= 3 && (
            <>
              <label htmlFor="sort">Sort by:</label>
              <select id="sort">
                <option>Sort by (Default)</option>
                <option>Price: Low to High</option>
                <option>Price: High to Low</option>
                <option>Newest</option>
              </select>
            </>
          )}
        </div>
      </div>

      {/* ✅ Step Content */}
      {step <= 3 ? (
        <>
          {/* ✅ Side Drawer */}
          <SideDrawer
            isOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
            filters={filters}
            setFilters={setFilters}
            resetFilters={resetFilters}
            filterOptions={filterOptions}
          />

          <div className="product-number">
            {filteredProducts.length} Products found |
          </div>

          <div className="product-list">
            {filteredProducts.map((product, index) => (
              <Card
                key={index}
                id={product.id}
                image={product.images}
                name={product.name}
                description={product.description}
                price={product.price}
              />
            ))}
          </div>
        </>
      ) : step === 4 ? (
        // ✅ Step 4 - Measurement Form
        <MeasurementForm />
      ) : (
        // ✅ Step 5 - Cart
        <Cart />
      )}
    </div>
  );
};

export default Products;
